<template>
  <div>
    <div class="image-header has-text-centered">
      <div class="is-size-1 domain-title">
        {{ $t('domains.title') }}
      </div>
      <slot />
    </div>
  </div>
</template>
<script>

export default {
  name: 'DomainHeader'
}
</script>

<style lang="scss" scoped>
@import '../../../sass/_variables.scss';
.image-header {
  margin-top: 8px;
  width: 100%;
  min-height: 250px;
  position: relative;
  background-size: cover;
  background-position: center;
  color: white;
  padding: 50px 40px 20px 40px;
  background-color: var(--tertiary-color-transparent);

  img {
    max-width: 350px;
  }
}

.image-header:before {
  content: '';
  background-image: url('../../assets/seo_background_greyscale.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: -1;
}

@media only screen and (max-width: 1023px) {
  .image-header {
    font-size: 1.5em;
    padding: 80px;
  }
}
</style>
